import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";

import { LINK_ITEM_CLASSES } from "./constants";

export const LinkItemContainer = styled(ListItem)(({ theme }) => ({
  cursor: "pointer",
  padding: 0,
  marginBottom: theme.spacing(2),
  "&:has([data-disabled=true])": {
    pointerEvents: "none",
  },

  [`& .${LINK_ITEM_CLASSES.anchor}`]: {
    textDecoration: "none",

    "& .MuiTypography-caption": {
      fontSize: 14,
    },
  },
}));
